import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ITrade } from "../interfaces/trade/ITrade";

enum DocumentServiceEnum {
  findMarriageCertificateByTradeId = "/find-marriage-certificate?tradeId=",
  postDocumentsByPrecatorioId = "/precatorio/",
  findSpouseDocIdByTradeId = "/get-spouse-doc-id?tradeId=",
  uploadGeneric = "/upload"
}

export default class DocumentService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/document");
  }

  public findMarriageCertificateByTradeId = async (tradeId): Promise<any> => await this.GET(DocumentServiceEnum.findMarriageCertificateByTradeId + tradeId);
  public postDocumentsByPrecatorioId = async (precatorioId, documents): Promise<any> => await this.POST(DocumentServiceEnum.postDocumentsByPrecatorioId + precatorioId, documents);
  public findSpouseDocIdByTradeId = async (tradeId): Promise<any> => await this.GET(DocumentServiceEnum.findSpouseDocIdByTradeId + tradeId);
  public putUploadGeneric = async data => await this.PUT(DocumentServiceEnum.uploadGeneric, data);

  public getContractSignatureKey = (trade: ITrade, contractType: string) => {
    if (trade && trade.documentList) {
      const contract = trade.documentList
        .sort(function(a, b) {
          return -(a.id - b.id);
        })
        .find(c => c.typeContract === contractType);
      if (contract) {
        return contract.signerKey;
      }
    }
    return null;
  };

  public getContractClosed = (trade: ITrade, contractType: string) => {
    if (trade && trade.documentList) {
      const contract = trade.documentList
        .sort(function(a, b) {
          return -(a.id - b.id);
        })
        .find(c => c.typeContract === contractType);
      if (contract) {
        return contract;
      }
    }
    return null;
  };
}



// WEBPACK FOOTER //
// ./src/services/api/Document.service.ts